import { render, staticRenderFns } from "./BroadcastItem.vue?vue&type=template&id=37d5a33a"
import script from "./BroadcastItem.vue?vue&type=script&lang=js"
export * from "./BroadcastItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports